import PropTypes from 'prop-types';
import FormHelperText from '@material-ui/core/FormHelperText';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';

class FormError extends React.PureComponent {

    render() {

        const { classes, id } = this.props;

        return (
            <FormHelperText id={id} data-test="form-error" className={classes.errorHelp}>{this.props.children}</FormHelperText>
        );
    }
}

FormError.propTypes = {
    id: PropTypes.string,
    classes: PropTypes.object,
    children: PropTypes.any
};

export default withStyles(styles)(FormError);